import { Component, NgZone, OnInit } from '@angular/core';
import { LocalStorageKeyEnum } from '../localStorage.key.enum';
import { UserService } from '../services/user.service';
import * as _ from 'lodash';
import { AuthService } from '../services/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription, timer } from 'rxjs';
declare const google: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apcAuthSrv: AuthService,
    private userService: UserService,
    private ngZone: NgZone
  ) { }

  user: any;
  loggedIn: boolean;
  returnUrl: string;
  subTime: Subscription = Subscription.EMPTY;
  async ngOnInit() {
    this.apcAuthSrv.logout();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    if (this.subTime) {
      this.subTime.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this.initializeGoogleLogin();
  }

  checkPermission() {
    this.userService
      .getIdentity()
      .then((permissions) => {
        localStorage.setItem(LocalStorageKeyEnum.PERMISSIONS_DOT_ANNOTATION, JSON.stringify(permissions));
        // permissions are coming from backend with dot annotation, we move it into tree anotation here to save it in localstorage
        var perms = {};
        _.forEach(permissions.permissions, function (value, key) {
          _.set(perms, key, value);
        });
        localStorage.setItem(
          LocalStorageKeyEnum.PERMISSIONS,
          JSON.stringify({ role: permissions.role, permissions: perms })
        );
        this.router.navigateByUrl(this.returnUrl);
        //window.location.href = '/dashboard';
      })
      .catch((error) => console.error(error));
  }

  initializeGoogleLogin() {
    if(google != typeof undefined && google != null){
      if(google.accounts != typeof undefined && google.accounts != null){
        if(google.accounts.id != typeof undefined && google.accounts.id != null){
          google.accounts.id.initialize({
            client_id: environment.googleAuthClientId,
            callback: data => this.handleCredentialResponse(data),
            itp_support: true,
            auto_select: true
          });
          if (document.getElementById("googleBtn")) {
            google.accounts.id.renderButton(
              document.getElementById("googleBtn"),
              {
                theme: "outline",
                size: "large",
              }
            );
          }
          google.accounts.id.prompt(this.callbackPrompt.bind(this));
        }
      }
    }
  }

  callbackPrompt(notification) {
    if ((notification.isNotDisplayed() || notification.isSkippedMoment()) && window.location?.pathname?.split("/")?.[1] !== "login") {
      console.log("One Tap prompt or the browser native credential manager are not avaible.");
      this.apcAuthSrv.logout();
      this.ngZone.run(() => {
        this.router.navigate(["/login"]);
      });
    }
  }

  handleCredentialResponse(response: any,) {
    this.ngZone.run(() => {
      this.user = response;
      this.loggedIn = response != null;
      localStorage.setItem(LocalStorageKeyEnum.USER, JSON.stringify(response.credential));
      this.checkPermission();
      let base64Url = response?.credential?.split('.')[1];
      let base64 = base64Url?.replace(/-/g, '+')?.replace(/_/g, '/');
      let jsonPayload = JSON.parse(decodeURIComponent(atob(base64)?.split('')?.map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join('')));
      let exp = jsonPayload?.exp || "";
      
      if (exp) {
        let expMill = new Date(exp * 1000 + 72000000).getTime() - new Date().getTime();
        let timerExp = timer(expMill);
        if (this.subTime) {
          this.subTime.unsubscribe();
        }
        this.subTime = timerExp.subscribe(() => {
          this.apcAuthSrv.logout();
          this.initializeGoogleLogin();
        });
      }
    });
  }
}
